import { useContext } from 'react'

import { Box, Flex, MediaQuery, rem, Stack } from '@mantine/core'

import { FeatureCardContext } from '../../context'

export const HorizontalLayout = () => {
  const { sectionName, heading, content, viewAll } = useContext(
    FeatureCardContext,
  )
  return (
    <Flex
      sx={(theme) => ({
        [theme.fn.smallerThan('sm')]: {
          gap: 24,
          flexDirection: 'column',
          alignItems: 'stretch',
          padding: `${rem(40)} ${rem(16)}`,
        },
        [theme.fn.largerThan('sm')]: {
          alignItems: 'center',
          gap: 64,
          padding: 48,
        },
      })}
    >
      <Box
        sx={(theme) => ({
          [theme.fn.largerThan('sm')]: {
            width: 345,
            flexShrink: 0,
          },
        })}
      >
        <Stack spacing={24}>
          <Stack
            sx={(theme) => ({
              gap: 12,
              [theme.fn.largerThan('sm')]: {
                gap: 16,
              },
            })}
          >
            {sectionName}
            {heading}
          </Stack>
          <MediaQuery smallerThan={'sm'} styles={{ display: 'none ' }}>
            <Box>{viewAll}</Box>
          </MediaQuery>
        </Stack>
      </Box>
      <Box
        sx={(theme) => ({
          [theme.fn.largerThan('sm')]: {
            width: `calc(100% - 345px - 64px)`,
          },
        })}
      >
        {content}
      </Box>
      <MediaQuery largerThan={'sm'} styles={{ display: 'none ' }}>
        <Box>{viewAll}</Box>
      </MediaQuery>
    </Flex>
  )
}
